import React, { Component } from 'react';
import moment from 'moment';

import FleximodoSensorsSettingsForm from './FleximodoSensorsSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import FleximodoSensorsModel from './FleximodoSensorsModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Card, Statistic, Popconfirm, Divider, message, Typography } from 'antd';

class FleximodoSensorsTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        fleximodoSensorsSettingsFormData: null
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    expandedRowRender(record) {
        return (
            <div>
                <Row style={{ marginBottom: 20 }}>
                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="Napětí baterie [mV]"
                            value={record.batteryVoltage ? record.batteryVoltage : '-'} />
                    </Col>
                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="Kapacita baterie [%]"
                            value={record.batteryCapacity ? record.batteryCapacity : '-'} />
                    </Col>
                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="Teplota [°C]"
                            value={record.temperature ? record.temperature : '-'} />
                    </Col>

                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="Type"
                            value={record.networkInfo && record.networkInfo.type ? record.networkInfo.type : '-'} />
                    </Col>
                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="RSSI [dBm]"
                            value={record.networkInfo && record.networkInfo.rssi ? record.networkInfo.rssi : '-'} />
                    </Col>
                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="On air [ms]"
                            value={record.networkInfo && record.networkInfo.on_air ? record.networkInfo.on_air : '-'} />
                    </Col>
                    <Col span={3}>
                        <Statistic
                            formatter={(value) => value != null ? value : '-'}
                            title="Radar only"
                            value={record.radar_only === true ? 'Ano' : 'Ne'} />
                    </Col>
                </Row>
            </div >
        );
    }

    render() {

        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Lokalita',
            dataIndex: 'parkingLocationName',
            key: 'parkingLocationName',
            width: 250,
            sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
        }, {
            title: 'Sériové číslo',
            dataIndex: 'serialNumber',
            key: 'serialNumber',
            width: 150,
            sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber)
        }, {
            title: 'Místo',
            dataIndex: 'slotNumber',
            key: 'slotNumber',
            width: 75,
            defaultSortOrder: 'ascend',
            sorter: (a, b) => defaultSorter(a.slotNumber, b.slotNumber),

        }, {
            title: 'Poslední komunikace',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 185,
            sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
            render: (text, record) => {
                if (!record.timestamp) {
                    return "-"
                } else {
                    if (moment(record.timestamp) <= moment().subtract(1, "days")) {
                        return (
                            <Badge
                                status="error"
                                text={moment(text).format('L LTS')}
                                title="Poslední komunikace před více než 1 dnem" />
                        );
                    } else if (moment(record.timestamp) <= moment().subtract(3, "days")) {
                        return (
                            <Badge
                                status="warning"
                                text={moment(text).format('L LTS')}
                                title="Poslední komunikace před více než 3 dny" />
                        );
                    } else {
                        return (
                            <Badge
                                status="success"
                                text={moment(text).format('L LTS')}
                                title="Vpořádku" />
                        );
                    }
                }
            },
        }, {
            title: 'Poslední změna stavu',
            dataIndex: 'lastStateChange',
            key: 'lastStateChange',
            width: 185,
            sorter: (a, b) => dateSorter(a.lastStateChange, b.lastStateChange),
            render: (text, record) => {
                if (!record.lastStateChange) {
                    return "-"
                } else {
                    return moment(record.lastStateChange).format(
                        "L LTS"
                    );
                }
            },
        }, {
            title: 'Stav',
            dataIndex: 'occ',
            key: 'occ',
            width: 150,
            filters: [{
                text: 'OBSAZENO',
                value: 1,
            }, {
                text: 'VOLNO',
                value: 0,
            }, {
                text: 'Kalibrace / neznámý stav / chyba',
                value: -1,
            }],
            filteredValue: filteredInfo.occ || null,
            onFilter: (value, record) => { return (parseInt(record.occ) === parseInt(value)) ? true : false },
            sorter: (a, b) => defaultSorter(a.occ, b.occ),
            render: (text, record) => {
                if (record.occ === 1) {
                    return (
                        <Badge
                            status="error"
                            text={"OBSAZENO"}
                            title="Obsazeno" />
                    );
                } else if (record.occ === 0) {
                    return (
                        <Badge
                            status="success"
                            text={"VOLNO"}
                            title="Volno" />
                    );
                } else if (record.occ === -1) {
                    return (
                        <Badge
                            color="#6d6d6d"
                            text={"Kalibrace / neznámý stav / chyba"}
                            title="Kalibrace / neznámý stav / chyba" />
                    )
                } else {
                    return '--'
                }
            }
        }, {
            title: 'Upozornění',
            dataIndex: 'reportsEnabled',
            key: 'reportsEnabled',
            width: 130,
            filters: [{
                text: 'ZAPNUTO',
                value: true,
            }, {
                text: 'VYPNUTO',
                value: false,
            }],
            filteredValue: filteredInfo.reportsEnabled || null,
            onFilter: (value, record) => {
                return ((record.reportsEnabled === value)) ? true : false
            },
            render: (text, record) => {
                if (record.reportsEnabled === true) {
                    return (
                        <Badge
                            status="success"
                            text="ZAPNUTO" />
                    );
                } else {
                    return (
                        <Badge
                            status="error"
                            text="VYPNUTO" />
                    );
                }
            }
        }, {
            title: 'Akce',
            key: 'Action',
            width: 200,
            render: (text, record) => {
                if (UserModel.isInRoles(['ADMIN', 'FLEXIMODO_SENSORS_WRITE'])) {
                    return (
                        <div>
                            <a onClick={(e) => {
                                this.setState({
                                    fleximodoSensorsSettingsFormData: record
                                });
                            }}>Nastavení</a>
                            <Divider type="vertical" />
                            <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                                this.props.onRemoveRow
                                    ? this.props.onRemoveRow(record.serialNumber)
                                    : null;
                            }} okText="Ano" cancelText="Ne">
                                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
                            </Popconfirm>
                        </div>
                    );
                }
            }
        }];

        return (
            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    onChange={this.handleChange}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                            ? parseInt(localStorage.getItem('table_pageSize'))
                            : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem('table_pageSize', size);
                        }
                    }}
                    expandedRowRender={this.expandedRowRender.bind(this)}
                    style={{ border: '0px' }} />
                <FleximodoSensorsSettingsForm
                    type="modal"
                    modalVisible={this.state.fleximodoSensorsSettingsFormData === null ? false : true}
                    initialValues={this.state.fleximodoSensorsSettingsFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({ fleximodoSensorsSettingsFormData: null });
                    }}
                    onSuccess={(form, values) => {
                        FleximodoSensorsModel.patch(this.state.fleximodoSensorsSettingsFormData.serialNumber, values)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    fleximodoSensorsSettingsFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }} />
            </div>
        );
    }
}

export default FleximodoSensorsTable;


// WEBPACK FOOTER //
// ./src/components/FleximodoSensorsTable.js